import { ref } from 'vue';

import { useConfirmDialogs } from '@modules/core/composables/dialogs';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_ADMIN_PLAYERS_BONUSES } from '@modules/players-bonuses/constants';
import { useChangePlayersBonusesMutation } from '@modules/players-bonuses/mutations';

interface PlayersBonusesListComposable {
  handleDelete(event: MouseEvent, bonusId: number): void;
}

export default function usePlayersBonusesList(): PlayersBonusesListComposable {
  const { getTranslation } = useI18n();
  const isLoading = ref(false);
  const { confirmDelete } = useConfirmDialogs();

  const {
    mutateAsync: changePlayersBonuses,
  } = useChangePlayersBonusesMutation();

  function deletePlayerBonus(bonusId: number): void {
    isLoading.value = true;
    void changePlayersBonuses(bonusId).finally(() => {
      isLoading.value = false;
    });
  }

  const handleDelete = (event: MouseEvent, bonusId: number): void => {
    confirmDelete({
      event,
      header: getTranslation(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'DESTROY').value,
      message: getTranslation(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'DESTROY_QUESTION').value,
      acceptLabel: getTranslation(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'ANSWER_YES').value,
      rejectLabel: getTranslation(TRANSLATION_ADMIN_PLAYERS_BONUSES, 'ANSWER_NO').value,
      accept: () => deletePlayerBonus(bonusId),
    });
  };

  return {
    handleDelete,
  };
}
